var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "formRef",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "140px" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "活动名称", prop: "activityName" } },
        [
          _c("el-input", {
            staticStyle: { width: "400px" },
            model: {
              value: _vm.form.activityName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "activityName", $$v)
              },
              expression: "form.activityName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动标题", prop: "activityTitle" } },
        [
          _c("el-input", {
            staticStyle: { width: "400px" },
            model: {
              value: _vm.form.activityTitle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "activityTitle", $$v)
              },
              expression: "form.activityTitle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "icon", prop: "coverImage" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "icon-uploader",
              attrs: {
                "file-list": _vm.fileList,
                size: "mini",
                action: "#",
                "list-type": "picture-card",
                limit: 1,
                "on-remove": function () {
                  return _vm.handleUploadRemove(1)
                },
                "auto-upload": true,
                accept: "image/*",
                "http-request": _vm.handleCustomUpload,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#999", "font-size": "12px" } }, [
            _vm._v("(500px * 400px)"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "生成数量", prop: "couponCount" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            attrs: { disabled: !!_vm.form.id },
            model: {
              value: _vm.form.couponCount,
              callback: function ($$v) {
                _vm.$set(_vm.form, "couponCount", $$v)
              },
              expression: "form.couponCount",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "优惠券组合", prop: "" } },
        _vm._l(_vm.form.activityPackageList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-bottom": "10px",
              },
            },
            [
              !!_vm.form.id
                ? _c("el-input", {
                    staticStyle: { width: "300px", "margin-right": "10px" },
                    attrs: { disabled: "" },
                    model: {
                      value: item.couponName,
                      callback: function ($$v) {
                        _vm.$set(item, "couponName", $$v)
                      },
                      expression: "item.couponName",
                    },
                  })
                : _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px", "margin-right": "10px" },
                      attrs: {
                        placeholder: "请输入优惠券，支持模糊查询",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        "remote-method": _vm.fetchCoupons1,
                        loading: _vm.couponLoading,
                      },
                      model: {
                        value: item.couponId,
                        callback: function ($$v) {
                          _vm.$set(item, "couponId", $$v)
                        },
                        expression: "item.couponId",
                      },
                    },
                    _vm._l(_vm.couponOptions1, function (coupon) {
                      return _c("el-option", {
                        key: coupon.thirdCouponId,
                        attrs: {
                          label: coupon.typeName,
                          value: coupon.thirdCouponId,
                        },
                      })
                    }),
                    1
                  ),
              _vm._v("\n\n            数量："),
              _c("el-input", {
                staticStyle: { width: "50px" },
                attrs: { disabled: !!_vm.form.id },
                model: {
                  value: item.quantity,
                  callback: function ($$v) {
                    _vm.$set(item, "quantity", $$v)
                  },
                  expression: "item.quantity",
                },
              }),
              _vm._v(" "),
              !_vm.form.id
                ? _c("div", [
                    _c("i", {
                      staticClass: "el-icon-circle-plus-outline",
                      staticStyle: {
                        color: "#589eff",
                        "font-size": "24px",
                        margin: "0 10px",
                      },
                      on: { click: _vm.handleAdd },
                    }),
                    _vm._v(" "),
                    _vm.form.activityPackageList.length > 1
                      ? _c("i", {
                          staticClass: "el-icon-remove-outline",
                          staticStyle: {
                            color: "#589eff",
                            "font-size": "24px",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleReduce(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "限制门槛", prop: "maxExchangeCount" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { disabled: !!_vm.form.id },
              model: {
                value: _vm.form.ruleType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "ruleType", $$v)
                },
                expression: "form.ruleType",
              },
            },
            [
              _c("el-radio", { attrs: { label: "YEAR" } }, [
                _vm._v("活动期间可兑换"),
              ]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "WEEK" } }, [
                _vm._v("周循环兑换次数"),
              ]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "MONTH" } }, [
                _vm._v("月循环兑换次数"),
              ]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "day" } }, [
                _vm._v("每满循环兑换次数"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.ruleType == "YEAR"
            ? _c(
                "div",
                [
                  _vm._v("\n            活动期间可兑换"),
                  _c("el-input", {
                    staticStyle: { width: "50px", margin: "0 10px" },
                    attrs: { size: "mini", disabled: !!_vm.form.id },
                    model: {
                      value: _vm.form.maxExchangeCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "maxExchangeCount", $$v)
                      },
                      expression: "form.maxExchangeCount",
                    },
                  }),
                  _vm._v("次\n        "),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.ruleType == "WEEK"
            ? _c(
                "div",
                [
                  _vm._v("\n            每周可以兑换"),
                  _c("el-input", {
                    staticStyle: { width: "50px", margin: "0 10px" },
                    attrs: { size: "mini", disabled: !!_vm.form.id },
                    model: {
                      value: _vm.form.maxExchangeCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "maxExchangeCount", $$v)
                      },
                      expression: "form.maxExchangeCount",
                    },
                  }),
                  _vm._v("次\n        "),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.ruleType == "MONTH"
            ? _c(
                "div",
                [
                  _vm._v("\n            每月可以兑换"),
                  _c("el-input", {
                    staticStyle: { width: "50px", margin: "0 10px" },
                    attrs: { size: "mini", disabled: !!_vm.form.id },
                    model: {
                      value: _vm.form.maxExchangeCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "maxExchangeCount", $$v)
                      },
                      expression: "form.maxExchangeCount",
                    },
                  }),
                  _vm._v("次\n        "),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.ruleType == "day"
            ? _c(
                "div",
                [
                  _vm._v("\n            每满"),
                  _c("el-input", {
                    staticStyle: { width: "50px", margin: "0 10px" },
                    attrs: { size: "mini", disabled: !!_vm.form.id },
                    model: {
                      value: _vm.form.maxExchangeCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "maxExchangeCount", $$v)
                      },
                      expression: "form.maxExchangeCount",
                    },
                  }),
                  _vm._v("天可以兑换1次\n        "),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "购买及使用规则", prop: "activityDesc" } },
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { type: "textarea", rows: 4 },
            model: {
              value: _vm.form.activityDesc,
              callback: function ($$v) {
                _vm.$set(_vm.form, "activityDesc", $$v)
              },
              expression: "form.activityDesc",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动时间", prop: "time" } },
        [
          _c("el-date-picker", {
            attrs: {
              type: "datetimerange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "yyyy-MM-dd HH:mm:ss",
            },
            model: {
              value: _vm.time,
              callback: function ($$v) {
                _vm.time = $$v
              },
              expression: "time",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动状态" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "status", $$v)
                },
                expression: "form.status",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未启用")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "门店", prop: "" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { disabled: !!_vm.form.id },
              model: {
                value: _vm.isNationWide,
                callback: function ($$v) {
                  _vm.isNationWide = $$v
                },
                expression: "isNationWide",
              },
            },
            [
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("不按门店")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("全部门店")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("选择门店")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.shoplist, function (city, index) {
            return _vm.isNationWide == 1
              ? _c(
                  "div",
                  { key: index, staticStyle: { "margin-top": "8px" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "font-weight": "600" },
                        attrs: {
                          checked: _vm.isCityAllSelected(city),
                          disabled: !!_vm.form.id,
                          indeterminate: _vm.isCityIndeterminate(city),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.toggleCity(city, $event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(city.regionName))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-checkbox-group",
                      {
                        staticStyle: { "margin-left": "20px" },
                        model: {
                          value: _vm.checkedCities,
                          callback: function ($$v) {
                            _vm.checkedCities = $$v
                          },
                          expression: "checkedCities",
                        },
                      },
                      _vm._l(city.dealerList, function (shop) {
                        return _c(
                          "el-checkbox",
                          {
                            key: shop.dealerId,
                            staticStyle: {
                              display: "inline",
                              "margin-right": "60px",
                            },
                            attrs: {
                              label: shop.dealerId,
                              disabled: !!_vm.form.id,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeShop(shop, $event)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(shop.dealerName) +
                                "\n                    "
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-left": "20px",
                                  display: "inline",
                                },
                              },
                              [
                                _vm._v("生成数量：\n                        "),
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    disabled: !!_vm.form.id,
                                    size: "mini",
                                  },
                                  model: {
                                    value: shop.num,
                                    callback: function ($$v) {
                                      _vm.$set(shop, "num", $$v)
                                    },
                                    expression: "shop.num",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "red" } }, [
            _vm._v(
              "实际生成券码数量：" +
                _vm._s(_vm.allCodeNum) +
                "，请确保券库存大于券码数量"
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }